import { createMuiTheme } from '@material-ui/core/styles';
import fonts from 'assets/fonts';
import { dimGray, steelblue, white } from 'styles/abstract/variables';

const openSansLight: object = {
    fontDisplay: 'block',
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 300,
    src: `url(${fonts.OpenSansLightTtf}) format('truetype')`,
};

const openSansRegular: object = {
    fontDisplay: 'block',
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 400,
    src: `url(${fonts.OpenSansRegularTtf}) format('truetype')`,
};

const openSansSemiBold: object = {
    fontDisplay: 'block',
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    src: `url(${fonts.OpenSansSemiBoldTtf}) format('truetype')`,
};

const openSansBold: object = {
    fontDisplay: 'block',
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 800,
    src: `url(${fonts.OpenSansBoldTtf}) format('truetype')`,
};

export const theme = createMuiTheme({
    overrides: {
        MuiAppBar: {
            root: {
                boxShadow: [
                    '0 2px 4px -1px rgba(0, 0, 0, 0)',
                    '0 4px 5px 0 rgba(0, 0, 0, 0.03)',
                    '0 1px 10px 0 rgba(0, 0, 0, 0.12)',
                ].join(','),
            },
        },
        MuiChip: {
            root: {
                backgroundColor: steelblue,
                borderRadius: 0,
                color: white,
                fontWeight: 400,
            },
        },
        MuiCssBaseline: {
            '@global': {
                '@font-face': [openSansLight, openSansRegular, openSansSemiBold, openSansBold],
            },
        },
        MuiFormLabel: {
            root: {
                color: dimGray,
                lineHeight: 1.3,
            },
        },
        MuiInputLabel: {
            outlined: {
                backgroundColor: white,
                paddingLeft: 0,
                paddingRight: 6,
            },
        },
        MuiOutlinedInput: {
            root: {
                borderRadius: 0,
            },
        },
    },
    typography: {
        fontFamily: [
            'Open Sans',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
    },
    palette: {
        background: {
            default: '#eaecec',
        },
    },
});
